var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"modal"},[_c('button',{staticClass:"btn-close img-btn",class:_vm.buttonPosition,on:{"click":_vm.close}},[_c('fa-icon',{attrs:{"icon":"times"}})],1),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }